interface Language {
    id: number;
    code: string;
    description: string;
    progress: number;
}

const EmptyLanguage: Language = {
    id: 0,
    code: '',
    description: '',
    progress: 0
};

export { EmptyLanguage };


export default Language;
